import publicUrls from "../../../routes/publicUrls";
import React, { useState, useRef, useCallback, useMemo } from "react";
import LotData from "./LotData";
import { Box, CircularProgress, Typography, Divider, IconButton } from "@mui/material";
import { useParams } from "react-router-dom";
import { getToken } from "../../../Model/User";
import { addfavorite, removefavorite } from "../../../Model/Auction";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import NoImage from "./../../../images/Banner/no_image.jpeg";
import WITHDRAWN_IMAGE from "./../../../images/Banner/withdrawn.jpg";
import { storeAuctionLot } from "../../../Model/LocalStorage";
import useMediaQuery from "@mui/material/useMediaQuery";
import { encodeId } from "../../../hash";

export default function Lot({ data }) {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(min-width:601px) and (max-width:1024px)");

  const { searching } = useParams();
  const token = getToken();
  const [pageNumber, setPageNumber] = useState(1);
  const [sortBy, setSortBy] = useState("price_desc");

  const { lotdata, setLot, hasMore, loading, error } = LotData(
    pageNumber,
    searching
  );

  const handleFavoriteToggle = async (e, lotId, isAdd) => {
    e.stopPropagation();
    if (!token) {
      const currentPath = window.location.pathname + window.location.search;
      window.location.href = `/login?redirect=${encodeURIComponent(
        currentPath
      )}`;
      return;
    }

    const lotIdx = lotdata.findIndex((l) => l.data.id === lotId);
    if (lotIdx > -1) {
      const updated = [...lotdata];
      updated[lotIdx].data.fav = isAdd ? 1 : 0;
      setLot(updated);
      try {
        isAdd
          ? await addfavorite({ lot_id: lotId })
          : await removefavorite({ lot_id: lotId });
      } catch (err) {
        console.error("API Error:", err);
      }
    }
  };


  const lotsList = useMemo(() => {
  return [...lotdata]; // clone to avoid direct mutation
}, [lotdata]);

  //       Number(a.data.hammer_price) > 0 && a.data.lot_status === "SOLD"
  //         ? Number(a.data.hammer_price)
  //         : Number(a.data.starting_price || 0);
  //       Number(b.data.hammer_price) > 0 && b.data.lot_status === "SOLD"
  //         ? Number(b.data.hammer_price)
  //         : Number(b.data.starting_price || 0);

  //   });
  // }, [lotdata, sortBy]);

  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prev) => prev + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const gotSinglePage = async (
    auction_name,
    title,
    auction_id,
    lotNumber,
    image
  ) => {
    const dataArray = { lot_id: auction_id, lotNo: lotNumber };
    storeAuctionLot(dataArray);



    window.location.href = publicUrls.lot(
      auction_name,
      encodeId(auction_id),
      lotNumber,
      `my-${title === null ? "untitle" : title.replace(/[^a-zA-Z0-9-_]/g, "")}`
    );
  };

  return (
    <section
      className="lotArea"
      style={{ width: "100%", padding: "40px 0", backgroundColor: "#fff" }}
    >
      <div className="container">
        
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            // ✅ Kung mobile, "center". Kung desktop, "flex-end" (o "flex-start" depende sa trip mo)
            alignItems: isMobile ? "center" : "flex-end",
            mb: 4, // Bahagyang tinaasan ang margin para mas Sotheby's
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 1 : 2,
            // ✅ Siguraduhin na center ang alignment ng text sa loob
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <Box>
            <Typography
              variant={isMobile ? "h5" : "h4"} // Mas maliit na font sa mobile para hindi awkward
              sx={{
                fontWeight: 400,
                letterSpacing: "-0.02em",
                color: "#1a1a1a",
                lineHeight: 1.2,
              }}
            >
              {searching ? `Results for "${searching}"` : "Auction Gallery"}
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: "#666",
                mt: isMobile ? 0.5 : 1,
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                fontSize: "0.75rem",
                fontWeight: 500,
              }}
            >
              {lotdata.length} Works Found
            </Typography>
          </Box>

          
          
        </Box>

        <Divider sx={{ mb: 6, backgroundColor: "#000" }} />

        
<div className="row g-5">
  {lotsList.map((value, i) => {
    const isLastElement = lotsList.length === i + 1;
    const imgUrl =
      value.data.isWithdrawn === 1
        ? WITHDRAWN_IMAGE
        : value.image?.length
        ? value.image[0].img_url
        : NoImage;

    // Font Constant
    const BELL_MT = "'Bell MT', serif";

    return (
      <div
        key={`${value.data.id}-${i}`}
        ref={isLastElement ? lastBookElementRef : null}
        className={isMobile ? "col-12" : isTablet ? "col-6" : "col-lg-3"}
      >
        <Box
          onClick={() =>
            gotSinglePage(
              value.data.auction_name,
              value.data.title,
              value.data.auction_id,
              value.data.lot_number,
              imgUrl
            )
          }
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%", 
            cursor: "pointer",
            transition: "all 0.3s ease-in-out",
            p: 2,
            border: "1px solid transparent",
            "&:hover": {
              borderColor: "#eee",
              boxShadow: "0px 10px 20px rgba(0,0,0,0.05)",
              backgroundColor: "#fff",
              "& .lot-image": { transform: "scale(1.05)" },
            },
            mb: 2,
          }}
        >
          
          <Box sx={{ overflow: "hidden", mb: 2, position: "relative", }}>
            <Box
              className="lot-image"
              sx={{
                width: "100%",
                height: isMobile ? 350 : 280,
                backgroundImage: `url(${imgUrl})`,
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                transition: "transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1)",
              }}
            />
          </Box>

          
          <Box sx={{ px: 0.5, flexGrow: 1, display: "flex", flexDirection: "column" }}>
            
            
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
              <Typography sx={{ fontWeight: 400, fontSize: "0.65rem", color: "#888", letterSpacing: "0.15em", fontFamily: BELL_MT }}>
                LOT {value.data.lot_number}
              </Typography>
              <IconButton size="small" sx={{ p: 0 }}>
                {value.data.fav === 1 ? <FavoriteIcon sx={{ fontSize: 18 }} /> : <FavoriteBorderIcon sx={{ fontSize: 18 }} />}
              </IconButton>
            </Box>

            
            {value.data.isWithdrawn !== 1 ? <>
            <Typography sx={{ color: "#666", fontWeight: 500, fontSize: "0.75rem", mb: 1, minHeight: "1.2em", fontFamily: BELL_MT }}>
              {value.data.auction_name}
            </Typography>

            
            <Typography
                    variant="artistName"
              sx={{
                fontWeight: 700,
                fontSize: "1.1rem",
                mb: 0.5,
                lineHeight: 1.2,
                minHeight: "1.2em",
                display: "-webkit-box",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
        
              }}
              dangerouslySetInnerHTML={{ __html: value.data.artist || "&nbsp;" }}
            />

            
            <Typography
            variant="titleName"
              sx={{
                fontStyle: "italic",
                color: "#666",
                fontSize: "0.9rem",
                lineHeight: 1.4,
                minHeight: "2.8em",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                mb: 2,
         
              }}
              dangerouslySetInnerHTML={{ __html: value.data.title || "&nbsp;" }}
            /></>:   <Box sx={{ mb: 2 }}>
            <Typography sx={{ fontWeight: 700, color: "error.main", fontSize: "1.15rem", textTransform: "uppercase" }}>
              Withdrawn
            </Typography>
            <Typography sx={{ color: "#999", fontSize: "0.9rem" }}>
              This lot has been removed from the auction.
            </Typography>
          </Box>}

            
            <Box sx={{ mt: "auto", pt: 1, borderTop: "1px solid #f9f9f9" }}>
              {value.data.isWithdrawn !== 1 ? (
                <Box  sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                  <Typography sx={{ fontWeight: 700, fontSize: "1.09rem", fontFamily: BELL_MT }}>
                    {value.data.lot_status === "SOLD" ? "Sold" : "Starting Bid"}
                  </Typography>
                  <Typography  sx={{ fontWeight: 700, fontSize: "1.09rem", fontFamily: BELL_MT }}>
                    ₱{(Number(value.data.hammer_price) > 0 && value.data.lot_status === "SOLD"
                      ? value.data.hammer_price
                      : value.data.starting_price ?? 0
                    ).toLocaleString()}
                  </Typography>
                </Box>
              ) : (
     ""
              )}
            </Box>
          </Box>
        </Box>
      </div>
    );
  })}
</div>
        {loading && (
          <Box sx={{ display: "flex", justifyContent: "center", py: 8 ,pt:10}}>
            <CircularProgress size={30} sx={{ color: "#000" }} />
          </Box>
        )}

        {!hasMore && lotdata.length > 0 && (
          <Typography
            sx={{
              textAlign: "center",
              mt: 8,
              color: "#ccc",
              fontSize: "0.8rem",
              letterSpacing: "0.2em",
              textTransform: "uppercase",
            }}
          >
            End of Collection
          </Typography>
        )}
      </div>
    </section>
  );
}
